<template>
    <div class="pointNumberLine">
        <div v-for="(item, index) in vitrinesMain" :key="index" class="dotWrapper">
            <div v-bind:class="pointNumber === index ? activeClass : notActive">
                <span v-if="pointNumber === index" class="number">{{ pointNumber + 1 }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        pointNumber: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            activeClass: "activePoint",
            notActive: "smallPoint",
            activeClassPoint: "activeClassPoint",
        };
    },
    computed: {
        vitrinesMain() {
            // return this.$store.getters.vitrinesMain;
            return this.$store.getters.vitrineArrayOnly;
        }
    },
    methods: {

    }
};
</script>

<style scoped>
.number {
    font-size: 14px;
    line-height: 1;
}

.pointNumberLine {
    height: 49px;
    background-color: #63C4C3;
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    bottom: 1px;
    padding: 0 10px;
}

.dotWrapper {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 0;
}

.activeClassPoint {
    opacity: 0.7;
    height: 50px;
    width: 50px;
    /* border: solid red 2px; */
    position: relative;
    font-size: 28px;
    bottom: 6px;
}

.smallPoint {
    width: 10px;
    height: 10px;
    border-radius: 60px;
    background: white;
    opacity: 0.8;
    flex-shrink: 0;
}

.activePoint {
    opacity: 1;
    background: rgb(255 255 255);
    height: 26px;
    width: 26px;
    border-radius: 50%;
    color: #63C4C3;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
}
</style>
